export default "__VITE_PUBLIC_ASSET__db44dd3c__"